import { render, staticRenderFns } from "./global.vue?vue&type=template&id=6c3f49d6"
import script from "./global.vue?vue&type=script&lang=js"
export * from "./global.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports